import { ErrorMessage, Field, Form, Formik, yupToFormErrors } from 'formik'
import * as Yup from 'yup';
import React, { useRef, useState, useEffect } from 'react'
import Rights from './Rights';
import { getCodeConsulta} from '../../services/denunciaService';
import * as notification from "../../utils/notification";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Row, Col, Button, InputGroup, Input as InputReact } from "reactstrap";
import { ModalCode } from "../common/ModalCode";

const Consulta = ({ showConsulta, setShowConsulta }) => {

    const [disabled, setDisabled] = useState(false);
    const [archivo, setArchivo] = useState(null);
    const [clearName, setClearName] = useState();
    const [clearPhone, setClearPhone] = useState();
    const [clearEmail, setClearEmail] = useState();
    const [code, setCode] = useState();
    const[password, setPassword] = useState();
    const fileRef = useRef();

    const [modalState, setModalState] = useState(false);
    const [text, setText] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        getCode();
    }, [])

    const getCode = async () => {
        const response = await getCodeConsulta();
        setCode(response.code);
        setPassword(response.password);
    }
    const inputHandlerCode = event => {
        setText(event.target.value);
    }
    const inputHandlerPassword = event => {
        setText(event.target.value);
    }
    const copy = async () => {
        await navigator.clipboard.writeText(code);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
    }
    const copyPassword = async () => {
        await navigator.clipboard.writeText(password);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
    }
    const handleSubmit = async (data, resetForm) => {
        const formData = new FormData();

        formData.append("nombre", clearName);
        formData.append("telefono", clearPhone);
        formData.append("email", clearEmail);
        formData.append("esAnonimo", data.esAnonimo);
        formData.append("descripcionConsulta", data.descripcionConsulta);
        formData.append("documento", archivo);
        formData.append("aceptaTerminos", data.aceptaTerminos);
        formData.append("code", code);
        formData.append("password", password);
        try {
            await axios({
                method: 'post',
                url: "form",
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(({ data }) => {
                if (data.success) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Consulta enviada correctamente',
                        showConfirmButton: false,
                        timer: 1000
                    })
                    setModalState(true);
                    resetForm();
                } else {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'No se ha podido guardar',
                        showConfirmButton: false,
                        timer: 1500
                    })
                }
            })
        } catch (error) {
            notification.error("", error.message || "Problemas en la llamada al servidor");
        }

    };

    const handleCancel = () => {
        setShowConsulta(!showConsulta)
    }

    const handleChangeName = (e) => {
        console.log(e);
        setClearName(e.target.value)
    }

    const handleChangePhone = (e) => {
        console.log(e);
        setClearPhone(e.target.value)
    }

    const handleChangeEmail = (e) => {
        console.log(e);
        setClearEmail(e.target.value)
    }
    return (
        <div>
            <Formik
                initialValues={{
                    nombre: '',
                    telefono: '',
                    email: '',
                    esAnonimo: false,
                    descripcionConsulta: '',
                    documento: archivo,
                    aceptaTerminos: false,

                }}
                onSubmit={(data, { resetForm }) => {

                    handleSubmit(data, resetForm);
                    // setShowConsulta(!showConsulta)
                }}
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={
                    Yup.object().shape({
                        nombre: Yup.string(),
                        telefono: Yup.string()
                            .matches(/(\+34|0034|34)?[ -]*(6|7)[ -]*([0-9][ -]*){8}/, { message: "Ingrese un número válido.", excludeEmptyString: false }),
                        email: Yup.string()
                            .email('El correo no tiene un formato válido'),
                        esAnonimo: Yup.boolean(),
                        documento: Yup.mixed().test("FILE_SIZE", "El archivo no debe superar los 5mb",
                            (value) => fileRef.current.files[0] !== undefined ? (fileRef.current.files[0].size <= 5000000 ? true: false) : true),
                        descripcionConsulta: Yup.string()
                            .min(10, 'Consulta muy corta, debe tener al menos 10 caracteres')
                            .required('Necesita describir la consulta'),
                        aceptaTerminos: Yup.boolean()
                            .oneOf([true], 'Debe aceptar los terminos')
                    })
                }
            >
                {
                    formik => (
                        <Form>
                            <div className="denuncia__main mt-0">
                                <div className="mb-5">                               
                                    <p className='denuncia__title'>Datos de Contacto</p>
                                    <div>
                                        <label className="form__checkbox-label">
                                            <Field
                                                name="esAnonimo"
                                                type="checkbox"
                                                onClick={() => {
                                                    setDisabled(!disabled);
                                                    setClearName(() => '');
                                                    setClearPhone(() => '');
                                                    setClearEmail(() => '');
                                                }}
                                            />
                                                Prefiero mantener mi anonimato
                                        </label>
                                        <label className="form__checkbox-label ml-4"> CODIGO : {code ? code : ''} </label>
                                        <ErrorMessage name="esAnonimo" component="span" />
                                    </div>
                                    <div>
                                        <Field disabled={disabled} value={ clearName } name='nombre' type='text' placeholder='Nombres y Apellidos *' className="form__input" onChange={ handleChangeName }/>
                                        <ErrorMessage name='nombre' component='span' />
                                    </div>
                                    <div className="mb-5">
                                        <Field disabled={disabled} value= { clearPhone } name='telefono' type='text' placeholder='Teléfono de Contacto *' className='form__input' onChange={ handleChangePhone }/>
                                        <ErrorMessage name='telefono' component='span' />

                                        <Field disabled={disabled} value= { clearEmail } name='email' type='email' placeholder='Correo electrónico *' className='form__input' onChange={ handleChangeEmail } />
                                        <ErrorMessage name='email' component='span' />
                                    </div>
                                    
                                    <p className='denuncia__title'>Datos de la consulta</p>
                                    <div>
                                        <Field className="form__input form__textarea" name='descripcionConsulta' as='textarea' placeholder='Indique la naturaleza general de consulta y facilite todos los detalles relacionados con la misma que puedan ser relevantes para el análisis y resolución de la misma *'></Field>
                                        <ErrorMessage name='descripcionConsulta' component='span' />
                                    </div>
                                </div>

                                <div>
                                    <p className='denuncia__title'>Agregar documento</p>
                                    <p className="form__checkbox-label">Documentación para anexar a la denuncia de cara a completar o dar soporte a los hechos denunciados</p>
                                    <input
                                        ref={fileRef}
                                        className="form__input mb-3"
                                        name="documento" type='file'
                                        placeholder='Adjuntar archivo (pdf, word, jpg…)'
                                        onChange={(e) => {
                                            setArchivo(e.target.files[0])
                                        }
                                        }
                                    />
                                    <ErrorMessage name="documento" component="span" />
                                    <div className='mb-2'>
                                        <label className="form__checkbox-label">
                                            <Field name="aceptaTerminos" type="checkbox" />
                                            He leído y comprendido la información sobre el <a>tratamiento del canal de denuncias</a>
                                        </label>
                                        <ErrorMessage name="aceptaTerminos" component="span" />
                                    </div>
                                </div>
                                <Rights />
                                <div className="form__button-container">
                                    <button type='reset' className='btn btn-cancel' onClick={ handleCancel }>Cancelar</button>
                                    <button type='submit' className='btn btn-primary'>Enviar</button>
                                </div>

                            </div>

                        </Form>
                    )
                }
            </Formik>
            <ModalCode        
                modalState={modalState}
                setModalState={setModalState}
                showOverlay={true}
                positionModal={'center'}
                padding={'0px '}
                >
                <div className="contenido-modal">
                    <h4 className="txt-modal">Guarde este código y contraseña para realizar seguimiento de su consulta</h4>
                    <InputGroup
                    className="input-code"
                    >
                    <Row><Col>Código</Col></Row>
                    <Row className='mb-2'>                       
                            <InputReact
                                className="txt-code"
                                value={code}
                                onChange={inputHandlerCode}
                            />
                            <Button
                                className="btn-input-code"
                                onClick={copy}
                                disabled={!code}
                            >
                                Copiar
                            </Button>
                    </Row>
                    <Row><Col>Contraseña</Col></Row>
                    <Row>                        
                            <InputReact
                                className="txt-code"
                                value={password}
                                onChange={inputHandlerPassword}
                            />
                            <Button
                                className="btn-input-code"
                                onClick={copyPassword}
                                disabled={!password}
                            >
                                Copiar
                            </Button>
                    </Row>
                    </InputGroup>
                    {
                    isCopied && (
                        <span className="span-copied">¡Copiado!</span>
                    )
                    }
                    <p className="msje-code">Se ha enviado correctamente. Guarde el código y contraseña para realizar cualquier consulta</p>
                    <button 
                    className="btn btn-primary btn-ok"
                    onClick={() => {
                        setModalState(false);
                        setShowConsulta(false)
                    }}
                    >Ok</button>
                </div>
            </ModalCode>
        </div>   
    )
}

export default Consulta
